module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_111_11.109f68d0.pdf";